<template>
  	<AddPinBatch />
</template>

<script>

// @ is an alias to /src
import AddPinBatch from "@/components/Client/PinBatch/AddPinBatch.vue";

export default {
  name: "AddPinBatchs",
  components: {
    AddPinBatch,
  },
};
</script>
